import React, { useMemo } from 'react';

import type { TSailingPortDetail } from '@/infra/types/voyageInfo/port';

import { useUIResourcePool } from '@/ducks/common/resources';

import './PortsSummary.scss';

type TPortsSummaryProp = {
  sailingPortDetails: TSailingPortDetail[];
};

const PortsSummary = ({ sailingPortDetails }: TPortsSummaryProp) => {
  const rootClassName = 'PortsSummary';

  const { portsSubheading } = useUIResourcePool({
    portsSubheading: 'Precheckout.timelineToggle.portsSubheading',
  });

  const portsCombinedList = useMemo(
    () =>
      sailingPortDetails
        ?.map((portDetails) => portDetails.portName?.split(',')[0])
        .filter((portName) => portName?.toLowerCase().trim() !== 'sailing')
        .reduce((acc, portName, index, portArray) => {
          const separator = index + 1 === portArray.length ? ' &' : ',';
          return index === 0 ? portName : `${acc}${separator} ${portName}`;
        }, ''),
    [sailingPortDetails],
  );

  return (
    <>
      {portsCombinedList?.length && (
        <div className={`${rootClassName}__wrapper`}>
          <h3 className={`${rootClassName}__header`}>{portsSubheading}</h3>
          <div className={`${rootClassName}__portsList`}>{portsCombinedList}</div>
        </div>
      )}
    </>
  );
};

export default PortsSummary;
